import {Button, Divider, FormControl, FormHelperText, Input, Stack, Textarea, Typography} from "@mui/joy";
import React, {useEffect, useMemo, useState} from "react";
import {useTestRoom} from "../../../../../hooks/useTestRoom";
import {QuestionGroup, RawQuestion} from "../../../../../models/question";
import {SectionName} from "../../../../../models/section";
import {debounce} from "lodash";

const IeltsOpenAnswerQuestionComponent = (props: {
    question: RawQuestion,
    questionGroupIndex: number,
    questionId: string,
    subSectionNumber: number,
    testId: string,
    sectionName: SectionName,
}) => {
    const testRoom = useTestRoom()
    const answerValue = testRoom.questionAttempts?.find(value => {
        return value.questionId === props.questionId && value.questionGroupIndex === props.questionGroupIndex
    })?.userAnswer
    const previousQuestionsCount = testRoom.questions
        .filter(q => q.subSectionNumber < testRoom.currentSubsectionNumber)
        .reduce((sum, q) => sum + (q as QuestionGroup).questions.length, 0)
    const questionNumber = previousQuestionsCount + props.questionGroupIndex + 1

    const handleAnswerQuestion = (value: string) => {
        testRoom.answerQuestion(value, props.question, {
            questionId: props.questionId,
            contentType: "text",
            isFromGroup: !!props.questionGroupIndex,
            questionGroupIndex: props.questionGroupIndex,
            testId: props.testId,
            sectionName: props.sectionName
        })
    }

    return <Stack gap={2}>
        <Stack>
            <Typography level={"title-lg"}>
                Question {questionNumber}
            </Typography>
            <Typography>
                {props.question.content}
            </Typography>
        </Stack>

        <FormControl>
            <Textarea
                autoFocus={props.questionGroupIndex === testRoom.currentSubsectionQuestionNumber}
                onFocus={(e) => e.target.setSelectionRange(testRoom.cursorPositionRef.current, testRoom.cursorPositionRef.current)}
                placeholder={"Answer here..."}
                onChange={event => {
                    testRoom.cursorPositionRef.current = event.target.selectionStart
                    handleAnswerQuestion(event.target.value)
                }}
                value={answerValue}
                minRows={1}/>
        </FormControl>
    </Stack>
}

export default IeltsOpenAnswerQuestionComponent